import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './navigation-bar.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class NavigationBar extends Component {
  @service messagingNavigation;

  <template>
    <div class="{{styles.component}} navigation-bar" data-test-navigation-bar>
      {{svgJar "messaging-locked" class="locked-icon"}}
      <h3 class="navigation-text" data-test-header>{{this.messagingNavigation.text}}</h3>
    </div>
  </template>
}
